<div class="screen-container">

  <div class="content-area d-flex flex-column align-items-center justify-content-center px-4 flex-grow-1">

    <div class="maint-icon-box mb-5">
      <i class="fas fa-cog fa-spin"></i>
    </div>

    <h1 class="page-title text-center mb-3">Maintenance</h1>
    <p class="page-sub text-center">We'll be back online shortly.<br>Thank you for your patience.</p>

  </div>

  <div class="praticko-footer text-center py-4">
    <h2 class="footer-brand mb-1">{{ 'common.brandName' | translate }}</h2>
    <small class="footer-sub d-block">{{ 'common.developedBy' | translate }}</small>
    <small class="footer-sub d-block">{{ 'common.versionInfo' | translate }}</small>
  </div>

</div>
